const config = {
  momentTimeZone: "America/New_York",
  title: "Guten Morgen LLC",
  paginationLimit: 25,
};

export default config;
